import React from "react";
import AdRenderer from "./AdRenderer";
interface AdSlotProps {
  slot: string;
  className?: string;
}

const AdSlot: React.FC<AdSlotProps> = ({ slot, className }) => {
  return (
    <div className={className}>
      <AdRenderer slot={slot} />
    </div>
  );
};

export default AdSlot;